// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3kxDV","colMin":"styles_colMin__2pyzL","colCheckbox":"styles_colCheckbox__21mTI"};